module.exports = __webpack_public_path__ + "static/media/integrations.7c884be1.svg";